import ColorsStyles from '@Styles/colors.scss';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { getBtnColor } from '@Components/Button/Button';
import LoadingButton from '@Components/LoadingButton/LoadingButton';
import Styles from './Modal.scss';

interface IModalFooterProps {
    id?: string;
    onCancel: () => void;
    cancelText?: string;
    isSubmitting?: boolean;
    onSubmit: () => void;
    canSubmit?: boolean;
    submitText?: string;
    hideSubmit?: boolean;
    submitColor?: string;
    cancelColor?: string;
}

export const ModalFooterContainer = (props) => {
    return <div className={Styles.modalFooter}>{props.children}</div>;
};

const ModalFooter = (props: IModalFooterProps) => {
    const {
        id,
        onCancel,
        cancelText = 'Cancel',
        isSubmitting,
        onSubmit,
        canSubmit = true,
        submitText = 'Submit',
        hideSubmit,
        submitColor = 'success',
        cancelColor = 'error',
    } = props;

    return (
        <ModalFooterContainer>
            <Button
                id={`${id}-cancel-btn`}
                size="small"
                color="info"
                variant="contained"
                style={{ marginRight: '1rem' }}
                onClick={onCancel}
                disabled={isSubmitting}
                role="modal-footer-cancel-btn"
                sx={{
                    backgroundColor: getBtnColor(cancelColor),
                    fontWeight: '400',
                    fontSize: '14px',
                    letterSpacing: '.02em',
                    lineHeight: '17px',
                    padding: '4px 10px',
                    '&:hover': {
                        backgroundColor: getBtnColor(cancelColor, true),
                    },
                }}
            >
                {cancelText}
            </Button>
            <LoadingButton
                id={`${id}-submit-btn`}
                color={submitColor}
                variant="contained"
                size="small"
                onClick={onSubmit}
                loading={isSubmitting}
                disabled={!canSubmit}
                role="modal-footer-submit-btn"
                style={{ visibility: hideSubmit ? 'hidden' : 'visible' }}
            >
                {submitText}
            </LoadingButton>
        </ModalFooterContainer>
    );
};

export default ModalFooter;
